import React from 'react';
import { Lightbulb, Home, Building2, Factory } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../lib/seo';

const ElectricalInstallations: React.FC = () => {
  const { t } = useTranslation();

  const newConstructionItems = [
    t('installationsPage.services.newConstruction.items.0'),
    t('installationsPage.services.newConstruction.items.1'),
    t('installationsPage.services.newConstruction.items.2'),
    t('installationsPage.services.newConstruction.items.3'),
    t('installationsPage.services.newConstruction.items.4')
  ];

  const renovationItems = [
    t('installationsPage.services.renovations.items.0'),
    t('installationsPage.services.renovations.items.1'),
    t('installationsPage.services.renovations.items.2'),
    t('installationsPage.services.renovations.items.3'),
    t('installationsPage.services.renovations.items.4')
  ];

  return (
    <>
      <SEO 
        title="Instalaciones Eléctricas Barcelona | Servicio Profesional"
        description="Instalaciones eléctricas profesionales en Barcelona. Instalación y renovación de cuadros eléctricos, enchufes y cableado. Electricista autorizado."
        canonical="/electrical-installations"
        type="website"
      />
      
      <div className="py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-8">{t('installationsPage.title')}</h1>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-gray-50 p-6 rounded-lg">
              <Home className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('installationsPage.features.residential.title')}</h3>
              <p>{t('installationsPage.features.residential.description')}</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <Building2 className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('installationsPage.features.commercial.title')}</h3>
              <p>{t('installationsPage.features.commercial.description')}</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <Factory className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('installationsPage.features.industrial.title')}</h3>
              <p>{t('installationsPage.features.industrial.description')}</p>
            </div>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-3xl font-bold mb-6">{t('installationsPage.services.title')}</h2>
            
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div>
                <h3 className="text-xl font-bold mb-4">{t('installationsPage.services.newConstruction.title')}</h3>
                <ul className="space-y-2">
                  {newConstructionItems.map((item, index) => (
                    <li key={index}>• {item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-4">{t('installationsPage.services.renovations.title')}</h3>
                <ul className="space-y-2">
                  {renovationItems.map((item, index) => (
                    <li key={index}>• {item}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="bg-yellow-50 p-8 rounded-lg mb-12">
              <h2 className="text-3xl font-bold mb-6">{t('installationsPage.process.title')}</h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('installationsPage.process.steps.consultation.title')}</h3>
                  <p>{t('installationsPage.process.steps.consultation.description')}</p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('installationsPage.process.steps.planning.title')}</h3>
                  <p>{t('installationsPage.process.steps.planning.description')}</p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('installationsPage.process.steps.installation.title')}</h3>
                  <p>{t('installationsPage.process.steps.installation.description')}</p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('installationsPage.process.steps.testing.title')}</h3>
                  <p>{t('installationsPage.process.steps.testing.description')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ElectricalInstallations;